module.exports = function() {
  return new Worker(__webpack_public_path__ + "203229d46d2988f22458.worker.js");
};